import React from 'react';
import { connect } from 'react-redux';
import { Header, Icon } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { get } from 'lodash';
import urls, { codeUrl } from '@/constants/urls';
import { canEditCohort } from '../../helper';
import { findQuery } from '../../state/shared';

const QueryDictionariesHeader = ({
  name,
  datasetCode,
  as = 'h4',
}) => (
  <Header as={as} className="aridhia-query-dictionaries-header">
    <Link to={codeUrl(urls.DATASETS, datasetCode)}>
      <Icon name="table" className="primary" />
      {name}
    </Link>
  </Header>
);

export const mapStateToProps = ({
  cohorts: {
    cohorts,
  },
  auth: {
    role,
  },
}, ownProps) => {
  const { cohort, query } = findQuery(cohorts, ownProps);

  return {
    name: get(query.dataset, 'catalogue.title'),
    datasetCode: query.dataset.code,
    canEdit: canEditCohort(cohort, role),
  };
};

export default connect(mapStateToProps)(QueryDictionariesHeader);
